import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-role-su-district-user-option",
	templateUrl: "./role-su-district-user-option.component.html",
	styleUrls: ["./role-su-district-user-option.component.css"],
})
export class RoleSuDistrictUserOptionComponent implements OnInit {
	constructor(private ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	RemoveRoles: boolean = false;
	RemoveGroups: boolean = false;

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////
	onUpdate() {
		var parms: any = {
			Success: true,
			RemoveRoles: this.RemoveRoles,
			RemoveGroups: this.RemoveGroups,
		};

		this.ref.close(parms);
	}

	onClose() {
		var parms: any = {
			Success: false,
			RemoveRoles: false,
			RemoveGroups: false,
		};

		this.ref.close(parms);
	}

	/////////////////////////////////////////////////////
}
